import InputField from './InputField.component';

export default InputField;